import Image from 'next/image'
import { getFileFromNwCDN } from '@nwwp/acquisition-ui/utils/nw-cdn'
import { ArrowIcon, cn } from '@nwwp/ui-shadcn'
import { BorderDoubleBox } from '~/components/BorderDoubleBox/BorderDoubleBox'
import { HeroCTA } from './HeroCTA'

export { HERO_CTA_ID } from './HeroCTA'

export const Hero = () => {
  return (
    <section aria-label="Hero section" className="flex flex-col tablet:h-[602px] tablet:flex-row">
      {/* Black text column — grows to fill remaining width */}
      <div
        className={cn(
          'dark relative z-10 flex-1 overflow-hidden',
          'h-[485px] p-6',
          'bg-dark-gradient',
          'tablet:h-full tablet:p-0',
          'tablet:rounded-6xl tablet:rounded-tl-none tablet:bg-background'
        )}
      >
        <BorderDoubleBox className="absolute top-[30px] right-[30px] hidden tablet:flex" />
        <BorderDoubleBox className="absolute bottom-[30px] left-[30px] hidden tablet:flex" />

        <div className="relative h-full tablet:flex tablet:items-center tablet:justify-center tablet:py-10">
          <div className="w-full tablet:w-115">
            <h1 className="relative text-title-2xl h-39 !leading-none text-foreground tablet:h-56">
              <span className="absolute top-0 left-0 w-full">Your financial</span>
              <i className={cn('absolute left-0 w-full font-normal', 'top-[49px]', 'tablet:top-[75.5px]')}>
                decisions deserve
              </i>
              <span
                className={cn(
                  'absolute font-normal whitespace-nowrap',
                  'top-[98px] left-[69px] w-[270px]',
                  'tablet:top-[147px] tablet:left-[87px] tablet:w-93 tablet:font-semibold'
                )}
              >
                a real partner
              </span>
              <ArrowIcon width={57} height={26} className="absolute top-[118px] left-0 tablet:hidden" />
              <ArrowIcon className="absolute top-[177.5px] left-0 hidden tablet:block" />
              <HeroMark
                className={cn('absolute', 'top-[15px] left-[314px] size-[29px]', 'tablet:left-99 tablet:size-12')}
              />
            </h1>

            <p className="mt-4 text-body text-foreground tablet:mt-8">
              You&rsquo;re at a stage where the financial decisions are bigger, the tradeoffs are harder, and the stakes
              keep getting higher. We&rsquo;re here to help you navigate it all.
            </p>

            <div className="mt-8">
              <HeroCTA />
            </div>
          </div>
        </div>
      </div>

      {/* Hero image — desktop only; fills height, tucks behind rounded black panel */}
      <div
        className={cn(
          'relative z-0 hidden w-192',
          'tablet:-ml-10 tablet:block tablet:h-full',
          'tablet:[&_img]:rounded-6xl tablet:[&_img]:rounded-tl-none',
          'tablet:[&_img]:rounded-tr-none tablet:[&_img]:rounded-bl-none'
        )}
      >
        <Image
          src={getFileFromNwCDN('hero@2x.webp')}
          alt="Hero"
          fill
          sizes="768px"
          priority
          style={{
            objectFit: 'cover',
            objectPosition: 'center 20%',
          }}
        />
      </div>
    </section>
  )
}

const HeroMark = ({ className }: { className?: string }) => {
  return (
    <div aria-hidden className={cn('flex', className)}>
      <span className="h-full w-1/2 rounded-r-full bg-corner-gradient" />
      <span className="h-full w-1/2 rounded-r-full bg-corner-gradient" />
    </div>
  )
}
